<template>
  <v-dialog
    v-model="isOpenModalDetail"
    :scrim="false"
    scrollable
    :width="$vuetify.breakpoint.mobile ? '' : '70%'"
    @click:outside="onClose"
  >
    <v-card
      class="card"
      :class="$vuetify.breakpoint.mobile ? 'help-card-mobile' : ''"
      :height="$vuetify.breakpoint.mobile ? '' : '100%'"
    >
      <div class="d-flex bg-titre">
        <div
          class="d-flex pl-3 mr-auto"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        >
          <div class="titre-h3 secondary--text align-self-center">
            Mon prix de vente
          </div>
          <AgrButton
            elevation="0"
            :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'ml-3'"
            class="btn-secondaire  align-self-center"
            color="primary darken-1"
            outlined
            large
            @click="isOpenModalEditContrat = true"
          >
            <span class="action text-truncate --text-branche">Ajouter une vente</span>
          </AgrButton>
        </div>
      
        <v-btn
          text
          class="btn-close"
          @click="onClose()"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-row
        class="mx-1"
      >
        <v-col
          v-if="hasDonneesRepartitionPrixContrat"
          cols="12"
          :md="hasPrixVenteMoyensPourGraineSelectionne ? 6 : 12"
        >
          <RepartitionTypeContrat
            :loading="loading.repartitionTypeContrat"
            :erreur="erreur.repartitionTypeContrat"
            :has-region-selected="filtresAdherent.regionsAgrial.length>0"
          />
        </v-col>
        <!-- Jauge de comparaison prix de vente -->
        <v-col
          v-if="hasPrixVenteMoyensPourGraineSelectionne"
          cols="12"
          :md="hasDonneesRepartitionPrixContrat ? 6 : 12"
        >
          <JaugePrixMoyens
            :annee-recolte="anneeRecolteSelected"
            :erreur="erreur.repartitionEvolutionTypeContrat"
            :loading="loading.repartitionEvolutionTypeContrat"
            :has-chip="false"
            has-select
            affichage-aide-prix-moyen
            :repartition-prix="repartitionEvolutionPrixVenteGroupe"
            :evolution-adherent="evolutionPrixVenteAdherent"
            :has-region-selected="filtresAdherent.regionsAgrial.length>0"
            has-help
            titre="Mon prix moyen"
            :type-contrat-selected="typeContratSelected"
            @updateFiltreTypeContrat="updateFiltreTypeContrat"
          />
        </v-col>
      </v-row>
      <v-card
        v-if="!loadingComparaison && !hasDonneesRepartitionPrixContrat && !hasPrixVenteMoyensPourGraineSelectionne"
        class="d-flex
          align-center
          flex-column pb-6 mt-3"
      >
        <img
          alt="no-comparaison"
          class="mt-5"
          src="@/assets/no-comparaison.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Pas de comparaison disponible pour cette graine et cette récolte.</span>
        </div>
      </v-card>
      <div
        v-else
        class="d-flex justify-center pb-3"
      >
        <span class="asterix">* Evolution par rapport à l’année précédente
        </span>
      </div>
      <v-dialog
        v-model="isOpenModalListeContrats"
        :scrim="false"
        scrollable
        persistent
        :fullscreen="!$vuetify.breakpoint.mobile"
        :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
      >
        <ListeContratsAdherentModal
          class="pa-3"
          :type-culture-selected="typeCultureSelected"
          :contrats="contratsModifiable"
          :loading="loading.contratAdherent"
          @openForm="openForm"
          @closeForm="closeForm"
          @reload="reload"
          @close="onCloseModalEditContrat()"
        />
      </v-dialog>
      <AgrButton
        elevation="0"
        class="btn-secondaire ml-3 my-3 align-self-center"
        color="primary darken-1"
        outlined
        :loading="loading.contratAdherent"
        large
        @click="onOpenModalListeContrat()"
      >
        <span class="action text-truncate --text-branche">Voir mes ventes</span>
      </AgrButton>
    </v-card>
    <v-dialog
      v-model="isOpenModalEditContrat"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
    >
      <SaisieContratAdherentModal
        :contrat="null"
        :contrats-vente="contratsVente"
        :type-culture-selected="typeCultureSelected"
        @close="isOpenModalEditContrat = false"
        @reload="reload"
      />
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {clone} from '@/utils/clone'
import { AgrButton } from '@agrial/ui'
import ListeContratsAdherentModal from '../../saisie-contrats/components/modal/liste-contrats-adherent-modal.vue'
import RepartitionTypeContrat from '../repartition-type-contrat.vue'
import JaugePrixMoyens from '@/views/detail-contrats/components/jauge-prix-moyens.vue'
import SaisieContratAdherentModal from '../../saisie-contrats/components/modal/saisie-contrat-adherent-modal.vue'

export default {
  name: 'DetailPrixVenteModal',
  components: {AgrButton, JaugePrixMoyens, ListeContratsAdherentModal, RepartitionTypeContrat, SaisieContratAdherentModal},
  props: {
    isOpenModalDetail: {
      type: Boolean,
      default: false
    },
    infosAbonnement: {
      type: Object,
      default: null
    },
    typeCultureSelected: {
      type: Object,
      default: null
    },
    codeGraineCulturialSelected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: {
        contratAdherent: false,
        repartitionTypeContrat: false,
        repartitionEvolutionTypeContrat: false
      },
      erreur: {
        contratAdherent: false,
        repartitionTypeContrat: false,
        repartitionEvolutionTypeContrat: false
      },
      typeContratSelected: null,
      contratsModifiable: [],
      isOpenModalEditContrat: false,
      isOpenModalListeContrats: false
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      contractualisation: 'contratVente/contractualisation',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      typesContrat: 'contratVente/filtreTypesContrats',
      repartitionTypeContrat: 'contratVente/repartitionTypeContrat',
      repartitionTypeContratGroupe: 'contratVente/repartitionTypeContratGroupe',
      evolutionPrixVenteAdherent: 'contratVente/evolutionPrixVenteAdherent',
      repartitionEvolutionPrixVenteGroupe:'contratVente/repartitionEvolutionPrixVenteGroupe'
    }),
    contratsVente () {
      return this.contractualisation!= null && this.contractualisation.contratVentes ? this.contractualisation.contratVentes : []
    },
    hasPrixVenteMoyensPourGraineSelectionne () {
      return this.evolutionPrixVenteAdherent != null && this.evolutionPrixVenteAdherent.prixVenteMoyenEnEuroParTonne != null && this.typesContrat.length > 0
    },
    hasDonneesRepartitionPrixContrat () {
     return this.repartitionTypeContrat != null
    },
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    loadingComparaison () {
      return this.loading.repartitionTypeContrat || this.loading.repartitionEvolutionTypeContrat
    }
  },

  created () {
    this.loadRepartitionTypeContrat()
    this.loadRepartitionEvolutionTypeContrat()
  },

  methods: {
    ...mapActions({
      getContrats: 'contratVente/getContractualisation',
      getRepartitionTypeContrat: 'contratVente/getRepartitionTypeContrat',
      getRepartitionTypeContratGroupe: 'contratVente/getRepartitionTypeContratGroupe',
      getEvolutionPrixVente: 'contratVente/getEvolutionPrixVente',
      getFiltresTypeContrat: 'contratVente/getFiltresTypeContrat',
      getRepartitionEvolutionTypeContratGroupe:'contratVente/construireResumeGroupeEvolutionRepartitionPrixVente',
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),
    loadRepartitionTypeContrat () {
      this.loading.repartitionTypeContrat = true
      this.erreur.repartitionTypeContrat = false
      Promise.all([
        this.getRepartitionTypeContrat(this.codeGraineCulturialSelected),
        this.getRepartitionTypeContratGroupe({filtres: this.filtresAdherent, codeGraine: this.codeGraineCulturialSelected})
      ])
        .catch(() => {
          this.erreur.repartitionTypeContrat = true
        })
        .finally(() => {
          this.loading.repartitionTypeContrat = false
        })
    },
    loadRepartitionEvolutionTypeContrat () {
      this.loading.repartitionEvolutionTypeContrat = true
      this.erreur.repartitionEvolutionTypeContrat = false
      this.getFiltresTypeContrat(this.codeGraineCulturialSelected)
        .then(() => {
          this.typeContratSelected = this.typeContratSelected!= null ? this.typeContratSelected : this.typesContrat.length > 0 ? this.typesContrat[0] : null
          if (this.typeContratSelected != null) {
            Promise.all([
              this.getEvolutionPrixVente({codeTypeContrat:this.typeContratSelected.code, codeGraine: this.codeGraineCulturialSelected}),
              this.getRepartitionEvolutionTypeContratGroupe({ filtres: this.filtresAdherent, codeTypeContrat: this.typeContratSelected.code, codeGraine: this.codeGraineCulturialSelected})
            ])
              .catch(() => {
                this.erreur.repartitionEvolutionTypeContrat = true
              })
              .finally(() => {
                this.loading.repartitionEvolutionTypeContrat = false
              })
          } else {
            this.loading.repartitionEvolutionTypeContrat = false
            this.erreur.repartitionEvolutionTypeContrat = false
          }
      })
      
    },
    updateFiltreTypeContrat (typeContrat) {
      this.typeContratSelected = typeContrat
      this.loadRepartitionEvolutionTypeContrat()
    },
    onOpenModalSaisieContrat () {
      this.$emit('openModalSaisieContrat')
    },
    onOpenModalListeContrat () {
      this.loadContrats()
      this.isOpenModalListeContrats = true
    },
    reload () {
      this.loadContrats()
      this.loadRepartitionTypeContrat()
      this.loadRepartitionEvolutionTypeContrat()
      this.$emit('reload')
    },
    loadContrats () {
      this.loading.contratAdherent = true
      this.erreur.contratAdherent = false
      this.getContrats(this.typeCultureSelected.code)
        .then(() => {
          let contractualisationModifiable = clone(this.contractualisation)
          let contrats = contractualisationModifiable.contratVentes
          contrats.forEach((c) => {
            c.isOpenForm = false
          })
          this.contratsModifiable = contrats.sort((a, b) => (b.contratAgrial - a.contratAgrial))
        })
        .catch(() => {
          this.erreur.contratAdherent = true
        })
        .finally(() => {
          this.loading.contratAdherent = false
        })
    },
    openForm (contrat) {
      this.contratsModifiable.forEach((c) => {
        c.isOpenForm = c.id === contrat.id
      })
    },
    closeForm () {
      this.contratsModifiable.forEach((c) => {
        c.isOpenForm = false
      })
    },
    onCloseModalEditContrat () {
      this.isOpenModalListeContrats = false
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.help-card-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}

.card.help-card-mobile {
  max-height: calc(100% - 56px);
}
.bg-titre {
  height: 70px;
}

@media (max-width: 960px) {
  .bg-titre {
    height: auto;
    padding: 12px 0;
  }
}
.card {
  border-radius: 0px !important;
  background-color: #f1f2f5;
}
.btn-close {
  position: absolute;
  right: 0;
}
</style>